// extracted by mini-css-extract-plugin
export default {"over":"Droppable_over__plUTn"};